import { setUpAPI, setUpAPIExchange } from "../../Utils/api.utils";

// Helper function for error handling
const handleAPIError = (error) => {
  console.log(error);
  return { isSuccess: false, error };
};

export const user_login = async (email, password) => {
  const data = {
    Action: "Login",
    Email: email,
    Password: password,
    apiKey: "c29fSpIgcFowwvzL3uKfjYVYnDZAKgyH",
  };

  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    console.log(error);
    return error;
  });

  return response.json();
};
export const user_profile_update = async (dataUser, user) => {
  const { userId } = user;
  return new Promise(async (resolve, reject) => {
    const data = {
      cmd: "iUserProfile_Update_account",
      UserId: userId,
      user_accounttype: dataUser.user_accounttype,
      user_accounttypecompany: dataUser.user_accounttypecompany,
      user_companytype: dataUser.user_companytype,
      user_companyname: dataUser.user_companyname,
      user_country:
        dataUser.country == undefined
          ? dataUser.user_country
          : dataUser.country,
      user_addressline1: dataUser.user_addressline1,
      user_phonenumber: dataUser.user_phonenumber,
      user_city: dataUser.user_city,
      user_state: dataUser.user_state,
      user_zipcode: dataUser.user_zipcode,
      user_DOB: dataUser.user_DOB,
      user_migratorystate: dataUser.user_migratorystate,
      user_link: dataUser.user_link,
      countryCode: dataUser.countryCode,
      enroll_influencer: dataUser.enroll_influencer,
    };

    try {
      const response = await setUpAPI("mUserProfile", data, "POST", null);
      const responseData = await response.json();
      if (response) {
        resolve(responseData);
      } else {
        reject(`There was an error retrieving the data, please try again.`);
      }
    } catch (error) {
      console.error("Error when making request:", error);
      reject(error);
    }
  });
};
//Update Notifications
export const user_profile_notifications = async (userId, command) => {
  return new Promise(async (resolve, reject) => {
    const data = {
      cmd: command,
      UserId: userId,
    };

    try {
      const response = await setUpAPI("mUserProfile", data, "POST", null);
      const responseData = await response.json();
      if (response) {
        resolve(responseData);
      } else {
        reject(`There was an error retrieving the data, please try again.`);
      }
    } catch (error) {
      console.error("Error when making request:", error);
      reject(error);
    }
  });
};
//2FA
export const user_profile_2FA = async (userId, command) => {
  return new Promise(async (resolve, reject) => {
    const data = {
      cmd: command,
      UserId: userId,
    };

    try {
      const response = await setUpAPI("mUserProfile", data, "POST", null);
      const responseData = await response.json();
      if (response) {
        resolve(responseData);
      } else {
        reject(`There was an error retrieving the data, please try again.`);
      }
    } catch (error) {
      console.error("Error when making request:", error);
      reject(error);
    }
  });
};
export const login_step_1 = async (email, password) => {
  const data = {
    Action: "Login2FAStep1",
    Email: email,
    Password: password,
  };

  const response = await setUpAPI("UserV3", data, "POST", null).catch(
    (error) => {
      console.log(error);
      return error;
    }
  );

  return response.json();
};

export const login_step_2 = async (sessionKey, authCode) => {
  const data = {
    Action: "Login2FAStep2",
    SessionKey: sessionKey,
    AuthCode: authCode,
  };

  const response = await setUpAPI("UserV3", data, "POST", null).catch(
    (error) => {
      console.log(error);
      return error;
    }
  );

  return response.json();
};
export const user_profile = async (userid) => {
  return new Promise(async (resolve, reject) => {
    const data = {
      cmd: "iUserProfile_GetProfile",
      UserId: userid,
    };

    try {
      const response = await setUpAPI("mUserProfile", data, "POST", null);
      const responseData = await response?.json();
      if (response) {
        resolve(responseData);
      } else {
        reject(`There was an error retrieving the data, please try again.`);
      }
    } catch (error) {
      console.error("Error when making request:", error);
      reject(error);
    }
  });
};

export const user_signup = async (values, formData) => {
  const data = {
    Action: "Register",
    Password: values.password,
    Email: values.email,
    formData: formData,
    ...values,
  };

  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });

  return response.json();
};

export const user_confirmation = async (email, userId, confirmationCode) => {
  const data = {
    Action: "Confirm",
    Email: email,
    userId: userId,
    confirmationCode: confirmationCode,
  };
  try {
    const response = await setUpAPI("User", data, "POST", null);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json();
  } catch (error) {
    return { isSuccess: false, message: "The code is invalid or expired" };
  }
};

export const user_forgetpass = async (email) => {
  const data = {
    Action: "ForgetPassword",
    Email: email,
  };
  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });
  return response.json();
};

export const user_login_confirm_resendcode = async (key) => {
  const data = {
    Action: "Resend2FACode",
    SessionKey: key,
  };
  const response = await setUpAPI("Userv3", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );
  return response.json();
};

export const user_resendcode = async (email) => {
  const data = {
    Action: "ResendCode",
    Email: email,
  };
  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });
  return response.json();
};

export const user_changepass = async (email, confirmationCode, password) => {
  const data = {
    Action: "ChangePassword",
    Email: email,
    Password: password,
    confirmationCode: confirmationCode,
  };
  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });
  return response.json();
};

export const user_emailExisting = async (email, formData) => {
  const data = {
    Action: "ExistsUser",
    Email: email,
    formData: formData,
  };

  try {
    const response = await setUpAPI("User", data, "POST", null);

    const responseBody = await response.text();
    return responseBody;
  } catch (error) {
    console.error("Error fetching user email existence:", error);
    return {
      isSuccess: false,
      message: "Error fetching user email existence",
      error,
    };
  }
};

export const user_loginApple = async (idToken) => {
  const data = {
    Action: "LoginApple",
    idToken: idToken,
  };
  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    console.log(error);
    return error;
  });

  return response.json();
};

export const user_signupApple = async (idToken, values) => {
  const data = {
    Action: "RegisterApple",
    idToken: idToken,
    ...values,
  };

  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });

  return response.json();
};

export const user_loginGoogle = async (idToken) => {
  const data = {
    Action: "LoginGoogle",
    idToken: idToken,
  };
  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    console.log(error);
    return error;
  });

  return response.json();
};

export const user_signupGoogle = async (idToken, values) => {
  const data = {
    Action: "RegisterGoogle",
    idToken: idToken,
    ...values,
  };

  const response = await setUpAPI("User", data, "POST", null).catch((error) => {
    return error;
  });

  return response.json();
};

export const payment_transaction = async (
  request,
  responseData,
  type,
  userId
) => {
  const data = {
    cmd: "AddLog",
    request: request,
    response: responseData,
    type: type,
    userId: userId,
  };

  const response = await setUpAPI(
    "PaymentTransaction",
    data,
    "POST",
    null
  ).catch((error) => {
    return error;
  });

  return response.json();
};

// PROFILE
export const getProfile = async () => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/user_details",
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// Get Marketcap
export const getMarketcap = async (id) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/auction/marketcap?auction_id=${id}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    console.log(error, "error");
  }
};

// SUMSUB KYC
export const kyc = async () => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/get_sumub_token",
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ADD APPLICANT IN KYC
export const addApplicantApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/add_applicant",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// WALLET BALANCE
export const getWalletBalance = async () => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/wallet/user/get_user_balance/fiat",
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return console.log(error, "error");
  }
};

export const getFundsTransfer = async ({ id }) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/auction/fund-transfer-status?auction_id=${id}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    console.log(error, "error");
  }
};

// ADD DEPOSIT INTEGRATED
export const addDeposit = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/paypal/deposit",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// DEPOSIT WITH STRIPE INTEGRATED
export const addDepositStripe = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/stripe/create-payment-intent",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// FOR DEPOSIT LIMIT
export const depositLimtApi = async () => {
  try {
    const response = await setUpAPI(
      "api/DuthAuction",
      {
        action: "GetAuctionDefault",
      },
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ADD WITHDRAW INTEGRATED
export const addWithdraw = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/paypal/withdraw",
      [data],
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// WALLET TRANSACTIONS
export const walletTransaction = async (page, limit) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-transaction-history/${page}/${limit}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// WALLET REQUEST
export const walletRequestTransaction = async (page, limit) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/billing-history?size=${limit}&page=${page}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const cancelwalletRequestTransaction = async (id) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/paypal/cancel-order`,
      { id },
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// USER FEE AMOUNT
export const getUserFeeAmountData = async (page, limit) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-fee-amount?page=${page}&limit=${limit}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
// PAIR LIST
export const getPairList = async () => {
  try {
    const response = await setUpAPIExchange(
      `orders/v1/order/user/pair_list`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// LOGIN OR REGISTER
export const loginOrRegister = async (
  email,
  userId,
  EnrollInfluencer,
  firstName,
  lastName,
  code
) => {
  const data = {
    userId: userId,
    email: email,
    is_influencer: EnrollInfluencer === "1" ? true : false,
    referral_code: code,
    first_name: firstName,
    last_name: lastName,
  };
  const response = await setUpAPIExchange(
    "users/v1/user/login_or_register",
    data,
    "POST",
    null
  ).catch((error) => {
    console.log(error);
    return error;
  });
  return response.json();
};

// PAIR BALANCE
export const getPairBalance = async (pair) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/pair_balance?pairName=${pair}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
// CREATE ORDER API
export const createOrderApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `orders/v1/order/user/create_order`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
// LOGOUT API
export const logoutApi = async () => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/logout`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const profitLossReportApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-pl-report`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
export const profitLossReportdownloadApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/download-pdf-report`,
      null,
      "GET",
      data
    );
    return await response.blob();
  } catch (error) {
    return handleAPIError(error);
  }
};
export const royaltyReportApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-pl-report`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const userFeeReportApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-fee-report`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
export const userCustodianFeeReportApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-custodial-report`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const usertxnReportApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-txn-report`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const userPortfolioApi = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/user/get-user-portfolios`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const getPairNotify = async (pair) => {
  try {
    const response = await setUpAPIExchange(
      `orders/v1/order/user/notify?pairName=${pair}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const setPairNotify = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `orders/v1/order/user/update_offline_units`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ########################################  INFLUENCER API'S   ###################################################

// ****** GET PROFILE ******
export const getInfluencerProfile = async (userId) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/get-influencer-profile?influencer=${userId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET FEE ******
export const getInfluencerFee = async (userId) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-influencer-fee?influencer=${userId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** UPDATE PROFILE ******
export const updateInfluencerProfile = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/update-influencer-profile",
      data,
      "PATCH",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** CREATE FEE ******
export const addInfluencerFee = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/create-influencer-fee-user",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** UPDATE FEE ******
export const updateInfluencerFee = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/update-influencer-fee-user",
      data,
      "PATCH",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET INFLUENCER RATING ******
export const getInfluencerRating = async (page, size, userId) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/get-influencer-rating?page=${page}&size=${size}&influencer=${userId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** ADD INFLUENCER RATING ******
export const addInfluencerRating = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/add-influencer-rating",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET ACTIVE INFLUENCER LIST ******
export const getActiveInfluencer = async (page, limit, auction_id) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-active-influencer-list?page=${page}&size=${limit}&auction_id=${auction_id}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET ACCEPTED INFLUENCER LIST ******
export const getAcceptedInfluencer = async (page, limit, auction_id) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/accepted-influencer-list?page=${page}&size=${limit}&auction_id=${auction_id}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** CREATE INFLUENCER INVITATION ******
export const createInfluencerInvitation = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/create-influencer-invitation",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** INVITE ALL INFLUENCER V2 ******
export const inviteAllInfleuencerV2 = async (auctionId) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/invite-all?auction_id=${auctionId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
// ****** SHARE EXTERNAL INVITATION ******
export const shareExternalInvitation = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "users/v1/user/send-influencer-invite",
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER INVITATION ******
export const getInfluencerInvitation = async (page, limit, search, status) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/list-influencer-invitation?page=${page}&size=${limit}&search=${search}&status=${status}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};
// ****** GET  INFLUENCER INVITATION By Client  ******
export const getInfluencerInvitationClient = async (data) => {
  try {
    const response = await setUpAPI(`api/mAuctions`, data, "POST", null);
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** UPDATE  INFLUENCER INVITATION ******
export const updateInfluencerInvitation = async (data) => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/update-influencer-invitation",
      data,
      "PATCH",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** DELETE  INFLUENCER INVITATION ******
export const deleteInfluencerInvitation = async (id, auctionId) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/delete-influencer-invitation?id=${id}&auction_id=${auctionId}`,
      null,
      "DELETE",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER BY AUCTION ******
export const getInfluencerList = async () => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/get-influencer-by-auction",
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  REFERRAL CODE OF AUCTION ******
export const getReferralCode = async (auctionId) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-referral-code?auction_id=${auctionId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER TOTAL EARNING ******
export const getInfluencerTotalEarning = async () => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/influencer/get-influencer-total-earning",
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER FINANCIAL AUCTION EARNING ******
export const getInfluencerAuctionEarning = async (page, size) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-influencer-financial-auction-report?page=${page}&size=${size}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER FINANCIAL EXCHANGE EARNING******
export const getInfluencerExchangeEarning = async (page, size) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-influencer-financial-exchange-report?page=${page}&size=${size}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** CREATE EXISTING USER TO INFLUENCER API ******
export const createInfluencer = async () => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/create-influencer`,
      null,
      "PATCH",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET  INFLUENCER INFO ******
export const getInfluencerInfo = async () => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/get-influencer-info`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ********************************************* END INFLUENCER API's ****************************************************

// ****** GET BANK DETAILS FOR WITHDRAW ******
export const getBankDetailsWithdraw = async (data) => {
  try {
    const response = await setUpAPI(`mUserProfile`, data, "POST", null);
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** MANUAL - DEPOSIT API ******
export const addManualDeposit = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/paypal/deposit-manual`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET AUCTION BOOK  ******
export const getAuctionBook = async (data) => {
  try {
    const response = await setUpAPI(`DuthAuction`, data, "POST", null);
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const getSymbols = async (page, size) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/auction/get-symbols-list?page=${page}&size=${size}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

export const getWalletOfflineSymbol = async (symbol) => {
  try {
    const res = await setUpAPIExchange(
      `wallet/v1/wallet/user/offline-units?symbol=${symbol}`,
      null,
      "GET",
      null
    );
    return await res.json();
  } catch (error) {}
};

// ************************ PRIVATE AUCTION BIDS{ACCEPT , REJECT , ADD , GET , EXPIRE} ************************

// ****** ADD BIDS ******
export const addBids = async (data) => {
  try {
    const response = await setUpAPI(
      `followingAuctionPrivate`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** GET BIDS ******
export const getBids = async (data) => {
  try {
    const response = await setUpAPI(
      `followingAuctionPrivate`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  ACCEPT BIDS ******
export const acceptBid = async (data) => {
  try {
    const response = await setUpAPI(
      `followingAuctionPrivate`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  REJECT BIDS ******
export const rejectBid = async (data) => {
  try {
    const response = await setUpAPI(
      `followingAuctionPrivate`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  UPDATE BID LIST ANTIER ******
export const updateBidList = async (bidId, status) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/wallet/auction/update-bid?bid_id=${bidId}&status=${status}`,
      null,
      "PATCH",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  TIER INFO API CLIENT ******
export const getTierInfo = async () => {
  try {
    const response = await setUpAPI(
      `TierInfo`,
      {
        cmd: "getdata",
      },
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  ADD INFLUENCER COMMENTS ******
export const addInfluencerComments = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/add-rating-comment`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******  MINIUM AMOUNT DEPOSIT AND WITHDRAW  ******
export const depositWithdrawAmountLimit = async () => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/paypal/settings`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ******PAY WITH WALLET API ******
export const payWithWallet = async (data) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/paypal/pay-via-wallet`,
      data,
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ****** ADMIN BANK DETAILS API ******
export const getAdminBankDetails = async (id) => {
  try {
    const response = await setUpAPIExchange(
      `users/v1/user/financial-information?id=${id}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ************ GET AUCTIONBOOK ONLY FOR INFLUENCER ************
export const getAuctionBookInfluencer = async (auctionId) => {
  try {
    const response = await setUpAPIExchange(
      `wallet/v1/influencer/get-influencer-referral-user-list?auction_id=${auctionId}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};

// ************ GET AUCTIONBOOK ONLY FOR INFLUENCER ************

export const getOrderbookUnits = async ({pairName,limit}) => {
  try {
    const response = await setUpAPIExchange(
      `orders/v1/order/user/order_book?pairName=${pairName}&limit=${limit}`,
      null,
      "GET",
      null
    );
    return await response.json();
  } catch (error) {
    return handleAPIError(error);
  }
};